import { TranslationChunksConfig } from '@spartacus/core';
export const customTranslationChunksConfig: TranslationChunksConfig = {
  // translation chunks defined in spartacus/core
  common: [
    'common',
    'forms',
    'pageMetaResolver',
    'spinner',
    'navigation',
    'searchBox',
    'sorting',
    'customLoginPage',
    'httpHandlers',
    'miniCart',
    'miniLogin',
    'skipLink',
    'carousel',
    'formErrors',
    'errorHandlers'
  ],
  address: ['addressForm', 'addressBook', 'addressCard', 'addressSuggestion'],
  asm: ['asm'],
  cart: ['cartDetails', 'cartItems', 'orderCost', 'voucher', 'saveForLaterItems', 'validateRealtimeStock', 'validation'],
  CartError: ['CartError'],
  checkout: ['checkoutOrderConfirmation', 'checkoutShipping', 'checkout', 'checkoutPO', 'checkoutProgress', 'checkoutAddress'],
  checkoutReview: ['checkoutReview'],
  forms: ['orderReturn', 'help', 'textSubcategories', 'contactUs', 'workWithUs', 'careCompany', 'file', 'maxFileSize', 'recaptcha'],
  internalServer: ['internalServer'],
  myAccount: [
    'orderDetails',
    'orderHistory',
    'myAccount',
    'closeAccount',
    'updateEmailForm',
    'updatePasswordForm',
    'updateProfileForm',
    'consentManagementForm',
    'myCoupons',
    'notificationPreference',
    'myInterests',
    'AccountOrderHistoryTabContainer',
    'returnRequestList',
    'returnRequest',
    'wishlist'
  ],
  myAccountV2Email: ['myAccountV2Email'],
  myAccountV2Order: ['myAccountV2OrderHistory', 'myAccountV2OrderDetails', 'myAccountV2Orders'],
  myAccountV2Password: ['myAccountV2PasswordForm'],
  myAccountV2UserProfile: ['myAccountV2UserProfile'],
  myTickets: ['myTickets'],
  notifyme: ['notifyme'],
  order: ['orderDetails', 'orderHistory', 'AccountOrderHistoryTabContainer', 'returnRequestList', 'returnRequest', 'reorder'],
  payment: ['paymentForm', 'paymentMethods', 'paymentCard', 'paymentTypes'],
  product: [
    'productDetails',
    'productList',
    'productFacetNavigation',
    'productSummary',
    'productReview',
    'addToCart',
    'TabPanelContainer',
    'variant',
    'addToWishList',
    'stockNotification',
    'itemCounter',
    'productView'
  ],
  pwa: ['pwa'],
  savedCart: ['savedCartDetails', 'savedCartList', 'savedCartCartPage', 'savedCartDialog', 'addToSavedCart'],
  shipping: ['shipping'],
  storeFinder: ['storeFinder'],
  stores: ['stores'],
  WebServiceIOError: ['WebServiceIOError'],
  userAccount: ['anonymousConsents', 'loginForm', 'checkoutLogin', 'register', 'authMessages'],
  userProfile: ['register,forgottenPassword'],
  user: ['anonymousConsents', 'checkoutLogin', 'authMessages']
};
